var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    viewBox: "0 0 48 60",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Engagement") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,13.39c0,2.1.81,2.41,8,9.6l6.87-6.86A3.89,3.89,0,0,0,28.12,9.5C26.21,9.5,25.39,10.63,24,12l-1.38-1.38A3.88,3.88,0,0,0,16,13.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.41,17.4c-.07.09-.6.61-2.93,2.93a12,12,0,1,1-11,0c-1.87-1.87-2.85-2.83-2.93-2.93C2,25.77,7.88,47,24,47S46.05,25.77,32.41,17.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,5V2a1,1,0,0,0-2,0V5A1,1,0,0,0,25,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.63,7.51a1,1,0,0,0,1.74-1l-1.5-2.6a1,1,0,0,0-1.74,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.37,7.51l1.5-2.6a1,1,0,0,0-1.74-1l-1.5,2.6A1,1,0,0,0,32.37,7.51Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagement);
export default __webpack_public_path__ + "static/media/Engagement.9f5ad1d295f4ca86cc0588e1d3fde169.svg";
export { ForwardRef as ReactComponent };